// docs/132: the players' colours in one World, worked out the same way by every screen and the
// encounter: the members in seat order (the keeper first, then by joining), each chosen colour
// (`player_colour`) kept, the rest given out by `assignColours`.
import type { Identity } from 'spacetimedb';
import { identityHex } from '../net/connection';
import { assignColours } from '../../game/board/players';

interface MemberRow { id: bigint; owner: Identity }
interface ColourRow { owner: Identity; colour: number }

/** The members' identity hexes in seat order: the keeper first, then by joining. */
export function seatOrder(members: readonly MemberRow[], keeperHex: string): string[] {
  return [...members]
    .sort((a, b) => (identityHex(a.owner) === keeperHex ? -1 : identityHex(b.owner) === keeperHex ? 1 : a.id < b.id ? -1 : 1))
    .map((m) => identityHex(m.owner));
}

/** owner hex → colour index (0-based into `PLAYER_COLOURS`). */
export function worldColours(members: readonly MemberRow[], chosen: readonly ColourRow[], keeperHex: string): Map<string, number> {
  return assignColours(seatOrder(members, keeperHex), new Map(chosen.map((c) => [identityHex(c.owner), c.colour])));
}

/** docs/132 PC10 (the module's `colour_locked`): a colour may still change in the lobby, or for a
 *  late joiner until their heroes are in a band; after that it is set for the World. */
export function colourOpen(opts: { begun: boolean; begunAtMs: number | undefined; joinedAtMs: number | undefined; inBand: boolean }): boolean {
  if (!opts.begun) return true;
  if (opts.begunAtMs === undefined || opts.joinedAtMs === undefined || opts.joinedAtMs <= opts.begunAtMs) return false;
  return !opts.inBand;
}
